// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Size and work caps. Zero means the host default; a host clamps every
 * value to its own caps.
 */
export class IdlOptions implements flatbuffers.IUnpackableObject<IdlOptionsT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): IdlOptions {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIdlOptions(bb: flatbuffers.ByteBuffer, obj?: IdlOptions): IdlOptions {
    return (obj || new IdlOptions()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsIdlOptions(bb: flatbuffers.ByteBuffer, obj?: IdlOptions): IdlOptions {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new IdlOptions()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  maxFileBytes(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  maxBundleBytes(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  maxBundleFiles(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  maxIncludeDepth(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  maxExpandedKeys(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  maxXmlNodes(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  maxInflatedBytes(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  maxInflateRatio(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  maxDiagnostics(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startIdlOptions(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addMaxFileBytes(builder: flatbuffers.Builder, maxFileBytes: number) {
    builder.addFieldInt32(0, maxFileBytes, 0);
  }

  static addMaxBundleBytes(builder: flatbuffers.Builder, maxBundleBytes: number) {
    builder.addFieldInt32(1, maxBundleBytes, 0);
  }

  static addMaxBundleFiles(builder: flatbuffers.Builder, maxBundleFiles: number) {
    builder.addFieldInt32(2, maxBundleFiles, 0);
  }

  static addMaxIncludeDepth(builder: flatbuffers.Builder, maxIncludeDepth: number) {
    builder.addFieldInt32(3, maxIncludeDepth, 0);
  }

  static addMaxExpandedKeys(builder: flatbuffers.Builder, maxExpandedKeys: number) {
    builder.addFieldInt32(4, maxExpandedKeys, 0);
  }

  static addMaxXmlNodes(builder: flatbuffers.Builder, maxXmlNodes: number) {
    builder.addFieldInt32(5, maxXmlNodes, 0);
  }

  static addMaxInflatedBytes(builder: flatbuffers.Builder, maxInflatedBytes: number) {
    builder.addFieldInt32(6, maxInflatedBytes, 0);
  }

  static addMaxInflateRatio(builder: flatbuffers.Builder, maxInflateRatio: number) {
    builder.addFieldInt32(7, maxInflateRatio, 0);
  }

  static addMaxDiagnostics(builder: flatbuffers.Builder, maxDiagnostics: number) {
    builder.addFieldInt32(8, maxDiagnostics, 0);
  }

  static endIdlOptions(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createIdlOptions(
    builder: flatbuffers.Builder,
    maxFileBytes: number,
    maxBundleBytes: number,
    maxBundleFiles: number,
    maxIncludeDepth: number,
    maxExpandedKeys: number,
    maxXmlNodes: number,
    maxInflatedBytes: number,
    maxInflateRatio: number,
    maxDiagnostics: number,
  ): flatbuffers.Offset {
    IdlOptions.startIdlOptions(builder);
    IdlOptions.addMaxFileBytes(builder, maxFileBytes);
    IdlOptions.addMaxBundleBytes(builder, maxBundleBytes);
    IdlOptions.addMaxBundleFiles(builder, maxBundleFiles);
    IdlOptions.addMaxIncludeDepth(builder, maxIncludeDepth);
    IdlOptions.addMaxExpandedKeys(builder, maxExpandedKeys);
    IdlOptions.addMaxXmlNodes(builder, maxXmlNodes);
    IdlOptions.addMaxInflatedBytes(builder, maxInflatedBytes);
    IdlOptions.addMaxInflateRatio(builder, maxInflateRatio);
    IdlOptions.addMaxDiagnostics(builder, maxDiagnostics);
    return IdlOptions.endIdlOptions(builder);
  }

  unpack(): IdlOptionsT {
    return new IdlOptionsT(
      this.maxFileBytes(),
      this.maxBundleBytes(),
      this.maxBundleFiles(),
      this.maxIncludeDepth(),
      this.maxExpandedKeys(),
      this.maxXmlNodes(),
      this.maxInflatedBytes(),
      this.maxInflateRatio(),
      this.maxDiagnostics(),
    );
  }

  unpackTo(_o: IdlOptionsT): void {
    _o.maxFileBytes = this.maxFileBytes();
    _o.maxBundleBytes = this.maxBundleBytes();
    _o.maxBundleFiles = this.maxBundleFiles();
    _o.maxIncludeDepth = this.maxIncludeDepth();
    _o.maxExpandedKeys = this.maxExpandedKeys();
    _o.maxXmlNodes = this.maxXmlNodes();
    _o.maxInflatedBytes = this.maxInflatedBytes();
    _o.maxInflateRatio = this.maxInflateRatio();
    _o.maxDiagnostics = this.maxDiagnostics();
  }

  unpackFields(...fields: string[]): IdlOptionsT {
    const t = new IdlOptionsT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("max_file_bytes")) {
      t.maxFileBytes = this.maxFileBytes();
    }
    if (fieldSet.has("max_bundle_bytes")) {
      t.maxBundleBytes = this.maxBundleBytes();
    }
    if (fieldSet.has("max_bundle_files")) {
      t.maxBundleFiles = this.maxBundleFiles();
    }
    if (fieldSet.has("max_include_depth")) {
      t.maxIncludeDepth = this.maxIncludeDepth();
    }
    if (fieldSet.has("max_expanded_keys")) {
      t.maxExpandedKeys = this.maxExpandedKeys();
    }
    if (fieldSet.has("max_xml_nodes")) {
      t.maxXmlNodes = this.maxXmlNodes();
    }
    if (fieldSet.has("max_inflated_bytes")) {
      t.maxInflatedBytes = this.maxInflatedBytes();
    }
    if (fieldSet.has("max_inflate_ratio")) {
      t.maxInflateRatio = this.maxInflateRatio();
    }
    if (fieldSet.has("max_diagnostics")) {
      t.maxDiagnostics = this.maxDiagnostics();
    }
    return t;
  }
}

export class IdlOptionsT implements flatbuffers.IGeneratedObject {
  constructor(
    public maxFileBytes: number = 0,
    public maxBundleBytes: number = 0,
    public maxBundleFiles: number = 0,
    public maxIncludeDepth: number = 0,
    public maxExpandedKeys: number = 0,
    public maxXmlNodes: number = 0,
    public maxInflatedBytes: number = 0,
    public maxInflateRatio: number = 0,
    public maxDiagnostics: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return IdlOptions.createIdlOptions(
      builder,
      this.maxFileBytes,
      this.maxBundleBytes,
      this.maxBundleFiles,
      this.maxIncludeDepth,
      this.maxExpandedKeys,
      this.maxXmlNodes,
      this.maxInflatedBytes,
      this.maxInflateRatio,
      this.maxDiagnostics,
    );
  }

  clone(): IdlOptionsT {
    const obj = new IdlOptionsT();
    obj.maxFileBytes = this.maxFileBytes;
    obj.maxBundleBytes = this.maxBundleBytes;
    obj.maxBundleFiles = this.maxBundleFiles;
    obj.maxIncludeDepth = this.maxIncludeDepth;
    obj.maxExpandedKeys = this.maxExpandedKeys;
    obj.maxXmlNodes = this.maxXmlNodes;
    obj.maxInflatedBytes = this.maxInflatedBytes;
    obj.maxInflateRatio = this.maxInflateRatio;
    obj.maxDiagnostics = this.maxDiagnostics;
    return obj;
  }

  equals(other: IdlOptionsT): boolean {
    if (this.maxFileBytes !== other.maxFileBytes) return false;
    if (this.maxBundleBytes !== other.maxBundleBytes) return false;
    if (this.maxBundleFiles !== other.maxBundleFiles) return false;
    if (this.maxIncludeDepth !== other.maxIncludeDepth) return false;
    if (this.maxExpandedKeys !== other.maxExpandedKeys) return false;
    if (this.maxXmlNodes !== other.maxXmlNodes) return false;
    if (this.maxInflatedBytes !== other.maxInflatedBytes) return false;
    if (this.maxInflateRatio !== other.maxInflateRatio) return false;
    if (this.maxDiagnostics !== other.maxDiagnostics) return false;
    return true;
  }
}

export function verifyIdlOptions(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 4);
    verifier.checkScalarField(tablePos, 20, 4);
  } finally {
    verifier.popDepth();
  }
}
